module.exports = __webpack_public_path__ + "img/sqr.7c045dd9.png";